<template>
  <ActiveProductMenuWrapper>
    <template v-slot:menu>
      <article class="menu-container" :class="{ disabled: playerLoader }">
        <!-- Old gameplan options -->
        <template v-if="!is3DAvailable">
          <div class="selected-color-container">
            <!-- Old gameplan Color picker -->
            <p class="label">Choose Color</p>
            <ColorPickerColorToChange
              :color="{ color: selectedVariantColor }"
              :isSingleMode="true"
            />
          </div>

          <!-- 2D Stock Variants -->
          <div class="choose-design-container">
            <div
              class="design-option"
              :class="{ selected: product.variant === selectedVariant }"
              v-for="(product, i) in productVariantsToShow"
              :key="i + '-v-' + product.id"
            >
              <ProductDisplay
                @selectVariant="handleSelectVariant"
                :product="product"
                :inheritedDesign="product.design"
              />
            </div>
          </div>
        </template>

        <!-- 3D Options -->
        <template v-if="is3DAvailable && cachedThreekitProductsLength">
          <!-- 3D Sublimated Color picker -->
          <div class="selected-color-container" v-if="isSublimated3D">
            <p class="label">Choose Color</p>
            <!-- Sublimation color picker -->
            <ColorPicker
              :colorPickerMode="'multiple'"
              :colorsToChange="designColors"
              :isThreekit="true"
              :colorsOptionsOverride="sublimationColors"
              @selectColor="handleChangeDesignColor"
            />
          </div>

          <!-- Show the Fabric and Design selections only in Outside view -->

          <!-- Fabric -->
          <label
            class="labels-in-column"
            id="change-fabric"
            v-if="
              fabricOptions &&
              fabricOptions.length &&
              isSublimated3D &&
              reversibleView === 'Outside'
            "
          >
            <span>Select a Fabric</span>
            <v-select
              :value="fabricCurrentValue"
              @input="handleChangeFabric"
              label="name"
              :options="fabricOptions"
              :disabled="fabricOptions.length < 2"
              :clearable="false"
              :searchable="false"
              class="box-shadow"
            >
              <template #selected-option>
                <div class="fabric-selected-option">
                  <strong>{{
                    fabricCurrentValue && fabricCurrentValue.name
                  }}</strong>

                  <p>{{ fabricCurrentValue.metadata.Description }}</p>
                </div>
              </template>
            </v-select>
          </label>

          <!-- Designs/Variants Items to select -->
          <p v-if="isSublimated3D && !reversibleView === 'Inside'">
            {{ title }}
          </p>

          <template v-if="isSublimated3D && reversibleView === 'Inside'">
            <div id="designs-switch-to-inside-container">
              <p>
                Please switch to
                <button @click="$emit('changeReversibleView')">Inside</button>
                to select a different design.
              </p>
            </div>
          </template>

          <div class="choose-design-container">
            <!-- Sublimated Design item -->
            <template v-if="isSublimated3D && reversibleView === 'Outside'">
              <div
                class="design-option"
                :class="{
                  selected:
                    activeDesignAttribute &&
                    design.assetId === activeDesignAttribute.value.assetId,
                }"
                v-for="(design, i) in designs"
                :key="i + '-d-' + design.name"
                @click="changeDesign(design.assetId)"
              >
                <ProductDisplay
                  @selectVariant="handleSelectVariant"
                  :product="product"
                  :inheritedDesign="product.design"
                  :threekitLayers="designsToShow[i]"
                />
                <div class="navigation-check">
                  <div class="checkmark"></div>
                </div>
                <div class="option-name">
                  <p>{{ design.name }}</p>
                </div>
              </div>
            </template>

            <!-- Stock variants items -->
            <template v-else-if="!isSublimated3D">
              <div
                class="design-option"
                v-for="(variant, i) in stockColors"
                :key="i + '-3d-v-' + variant.name"
                :class="{
                  selected:
                    actualVariant && variant.id === actualVariant.value.assetId,
                }"
                @click="handlechangeStockVariant(variant.id)"
              >
                <ProductDisplay
                  @selectVariant="handleSelectVariant"
                  :product="product"
                  :inheritedDesign="product.design"
                  :threekitLayers="variantsToShow[i]"
                />
                <div class="navigation-check">
                  <div class="checkmark"></div>
                </div>
                <div class="option-name">
                  <p>{{ variant.name && variant.name.replace(/-/g, " ") }}</p>
                </div>
              </div>
            </template>
          </div>
        </template>
      </article>
    </template>
  </ActiveProductMenuWrapper>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import ColorPicker from "@/components/Projects/Project/Colors/ColorPicker.vue";
import ColorPickerColorToChange from "@/components/Projects/Project/Colors/ColorPickerColorToChange";
import ProductDisplay from "@/components/Projects/Product/ProductDisplay/ProductDisplay.vue";
import ActiveProductMenuWrapper from "@/components/Projects/Project/ActiveProduct/ActiveProductMenuWrapper.vue";
export default {
  name: "ActiveProductColorsAndDesigns",

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters("project", ["getColorById", "getColorByStockName"]),
    ...mapGetters("project", ["is3DAvailable"]),

    ...mapGetters("threekit", [
      "activeProduct",
      "activeStyleName",
      "activeDesignAttribute",
      "actualVariant",
      "designs",
      "get2DGroupedLayers",
      "designColors",
      "mapThreekitColorWithConstantColors",
      "isSublimated",
      "isSublimated3D",
    ]),

    ...mapState("threekit", {
      cachedThreekitProductsLength(state) {
        return (
          state.cachedTKData.products.length ||
          Object.keys(state.cachedTKData.products).length
        );
      },
      sublimationColors(state) {
        return state.sublimationColors;
      },

      playerLoader(state) {
        return state.playerLoader;
      },

      reversibleView(state) {
        return state.reversibleView;
      },
    }),

    //Old variants pngs
    productVariantsToShow() {
      return this.product.variants?.map((variant) => {
        return {
          ...this.product,
          variant: variant.color_name?.trim(),
        };
      });
    },

    selectedVariant() {
      return this.product.variant;
    },

    selectedVariantColor() {
      //Threekit
      if (this.activeStyleName) {
        const selectedVariantColorName = this.stockColors?.find(
          (variant) => variant.id === this.actualVariant.value.assetId
        )?.name;
        return this.getColorByStockName(selectedVariantColorName);
      }

      const selectedVariantColorFamilyId = this.product.variants?.find(
        (variant) => variant.color_name?.trim() === this.selectedVariant?.trim()
      )?.color_family;
      return this.getColorById(selectedVariantColorFamilyId);
    },

    //3D - Threekit

    globalConfiguratorAttributes() {
      return this.$store.state.threekit.globalConfigurator?.getDisplayAttributes();
    },

    fabricAttributes() {
      return this.globalConfiguratorAttributes?.filter(
        (attribute) => attribute.name === "Fabric"
      )?.[0];
    },

    fabricOptions() {
      return this.fabricAttributes?.values?.map((opt) => opt?.name);
    },

    fabricCurrentValue() {
      return this.fabricAttributes?.values?.find(
        (opt) => opt?.assetId === this.fabricAttributes.value?.assetId
      );
    },

    //Sublimated
    designsToShow() {
      if (!this.designs) {
        return [];
      }
      const color1 = this.designColors?.[0]?.color?.chromagear_name;
      const color2 = this.designColors?.[1]?.color?.chromagear_name;
      const color3 = this.designColors?.[2]?.color?.chromagear_name;

      const designs = this.designs?.map((design) => {
        return this.get2DGroupedLayers({
          styleName: design?.styleName,
          designName: design?.name,
          color1,
          color2,
          color3,
        });
      });

      // //Sort alphabetically
      // const sorteDesigns = designs?.sort((a, b) => {
      //   if (a?.name < b?.name) return -1;
      //   if (a?.name > b?.name) return 1;
      //   return 0;
      // });

      // return sorteDesigns;
      return designs;
    },

    stockColors() {
      // if (!this.actualVariant) return [];
      // const checkMetadata = false;
      //get all the variants that are available on the stock property

      //Do not show the 'inside's variants
      const filteredStock = this.activeProduct?.stock?.filter(
        (c) => c && !c?.tags?.includes("color_inside")
      );

      //Sort alphabetically
      const sortedStock = filteredStock?.sort((a, b) => {
        if (a?.name < b?.name) return -1;
        if (a?.name > b?.name) return 1;
        return 0;
      });

      return sortedStock;
    },

    title() {
      return this.isSublimated3D ? "Choose your design" : "Choose your color";
    },

    //Stock
    variantsToShow() {
      return this.stockColors?.map((color) => {
        return this.get2DGroupedLayers({
          styleName: this.activeStyleName,
          asset1: color?.id,
        });
      });
    },
  },

  methods: {
    ...mapActions("project", [
      "changeActiveProductVariant",
      "resetEditableProduct",
    ]),
    ...mapActions("threekit", [
      "changeStockVariant",
      "changeDesign",
      "changeFabric",
      "handleChangeDesignColor",
    ]),

    handleSelectVariant(value) {
      this.changeActiveProductVariant(value);
    },

    handleNextStep() {
      this.resetEditableProduct();
      this.$emit("next");
    },

    //threeKit
    async handlechangeStockVariant(assetId) {
      console.log("playerLoader :", this.playerLoader);
      if (!this.playerLoader) {
        await this.changeStockVariant(assetId);
      }
    },

    handleChangeFabric(value) {
      const assetId = this.fabricAttributes?.values?.find(
        (opt) => opt?.name === value
      )?.assetId;

      this.changeFabric(assetId);
    },
  },
  watch: {
    actualVariant() {
      console.log("actualVariant: ", this.actualVariant);
    },
  },
  components: {
    ColorPicker,
    ColorPickerColorToChange,
    ProductDisplay,
    ActiveProductMenuWrapper,
  },
};
</script>
<style lang="scss">
.menu-container {
  display: flex;
  flex-direction: column;

  &.disabled {
    .design-option,
    .design-option:hover {
      cursor: not-allowed !important;
    }
  }

  .selected-color-container {
    grid-area: 1/1/2/-1;
    width: 100%;
    margin-bottom: 1.5rem;

    p.label {
      margin-bottom: 1rem;
    }
  }

  .choose-design-container--title {
    margin-bottom: 0.5rem;
  }

  .choose-design-container {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: 150px;
    grid-gap: 1rem;
    p.title {
      grid-area: 1/1/2/-1;
    }
    .design-option {
      display: flex;
      flex-direction: column;
      border: 1px solid $placeholder;
      border-radius: 10px;
      padding: 0.2rem 0;
      cursor: pointer;
      transition: all 0.2s ease-in-out;
      max-width: 130px;

      .product-display {
        height: 85%;
        display: flex;
        justify-content: center;
      }

      .navigation-check {
        position: absolute;
        left: 5%;
        top: 5%;
        visibility: hidden;
      }

      .option-name {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        p {
          font-size: 0.9rem;
          text-align: center;
          /* margin-top: 0.5rem; */
          text-transform: capitalize;
          color: $placeholder;
        }
      }

      &.selected,
      &:hover {
        border: 1px solid $playbookColor;
        background: white;
        filter: drop-shadow(0px 1px 2px rgba(40, 42, 48, 0.2));

        .option-name {
          p {
            color: $black;
          }
        }
      }

      &.selected {
        .navigation-check {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          background: $playbookColor;
          display: flex;
          align-items: center;
          justify-content: center;
          visibility: visible;
          transition: all 0.1s;
          .checkmark {
            /* display: inline-block; */
            transform: rotate(45deg);
            height: 6px;
            width: 3px;
            margin-bottom: 1px;
            // margin-left: 1px;
            border-bottom: 1px solid white;
            border-right: 1px solid white;
            transition: all 0.1s;
          }
        }
      }
    }

    @media screen and (max-width: 1366px) {
      grid-template-columns: repeat(3, 1fr);
    }
    @media screen and (max-width: 960px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media screen and (max-width: 576px) {
      display: flex;
      flex-direction: column;
      align-items: center;

      .design-option {
        min-height: 150px;
      }
    }
  }

  .labels-in-column {
    width: 50%;
    margin-bottom: 2rem;
    &#change-fabric {
      width: 100%;
    }
    & > span {
      display: block;
      margin-bottom: 0.5rem;
    }

    .fabric-selected-option {
      display: flex;
      flex-direction: column;
    }
  }

  #designs-switch-to-inside-container {
    button {
      background: none;
      text-decoration: underline;
    }
  }
}
</style>
